import React, {useEffect, useState} from 'react'
import {useGetOptionsSelect} from "../../../../hooks/useGetOptionsSelect/useGetOptionsSelect";
import {
    getDataToCreateLicenciaAPI, getHorariosLicenciasByEmpleadoAPI,
    getTiposLicenciasToCreateSolicitudAPI, ToggleRegistradoEnOfisisAPI, ToggleTieneBonoCapillaAPI
} from "../../../../consumers/backendApisUrls";
import {
    calculateDaysInBetween,
    initialAllOptionPromises,
    isNullOrUndefinded, mapDropDownOptionsFromBackendToSelectOptionsNeededForLibrary,
} from "../../../../helper/utils";
import InputSelect from "../../../../components/modalComponents/InputSelect";
import {usePropsSelect} from "../../../../hooks/useProps/usePropsSelect";
import {useManagePostRequest} from "../../../../hooks/useManagePostRequest/useManagePostRequest";
import InputText from "../../../../components/modalComponents/InputText";
import {usePropsInputs} from "../../../../hooks/useProps/usePropsInput";
import {Div} from "../components/Components";
import InputDate from "../../../../components/modalComponents/InputDate";
import InputUploadFile from "../../../../components/modalComponents/InputUploadFile";
import {EXTENSION_PDF, EXTENSIONES_VALIDAS_DE_IMAGENES} from "../../../../constants/hardCodedConstants";
import InputTextArea from "../../../../components/modalComponents/InputTextArea";
import useDidMountEffect from "../../../../hooks/useDidMountEffect/useDidMountEffect";
import {useManageGetRequest} from "../../../../hooks/useManageGetRequest/useManageGetRequest";
import {toast} from "react-toastify";
import {AlertErrorMaxFileSizeMessageGeneric} from "../../../../components/alerts/AlertErrorMaxFileSizeMessage";
import InputBool from "../../../../components/modalComponents/InputBool";
import {estados} from "../../../../constants/states";
import PreviewFormato from "./PreviewFormato";
import ConfirmarActualizar from "./ConfirmarActualizar";

const KEYS_DROPDOWN = ["IdTipoLicenciaCondicion", "HoraInicio", "HoraFin"];

const LicenciaCondicion = ({SECTION_NAME, idEmpleado,formValuesLicencias: formValues, setFormValuesLicencias: setFormValues, KEYS, fromAdminPage, isCreate, isEditable,  showConfirmarActualizarBeforePreview =false, handleUpdateFromPreview, togglePreviewFromMainModal, tipoLicenciaHaSidoEditado }) => {
    const [allDropdowns, setAllDropdowns] = useState([]);
    const [getOption] = useGetOptionsSelect();

    const [selectProps] = usePropsSelect(allDropdowns, formValues, setFormValues, SECTION_NAME);
    const [commonProps] = usePropsInputs(formValues, setFormValues, SECTION_NAME);

    const [selectedTipoLicencia, setSelectedTipoLicencia] = useState({})

    const [executeManagePost] = useManagePostRequest();
    const [executeMangGet] = useManageGetRequest();

    const [isUploading, setIsUploading] = useState(false);
    const [isUploadingSutento, setIsUploadingSustento] = useState(false);

    const [horasInicioOptions, setHorasInicioOptions] = useState([])
    const [horasFinOptions, setHorasFinOptions] = useState([])
    const [allHorasOptions, setAllHorasOptions] = useState([])

    const [aprobadorDisponible, setAprobadorDisponible] = useState(false);

    const [showModalPreviewFormato, setShowModalPreviewFormato] = useState(false);
    const [showModalConfirmarActualizar, setShowModalConfirmarActualizar] = useState(false);


    const getDropdowns = async () => {
        //setIsLoading(true);
        const dropdownsPromises = () => [
            getOption(getTiposLicenciasToCreateSolicitudAPI()),
            getOption(getHorariosLicenciasByEmpleadoAPI(idEmpleado)),
            getOption(getHorariosLicenciasByEmpleadoAPI(idEmpleado)),
        ];
        await initialAllOptionPromises(
            dropdownsPromises,
            KEYS_DROPDOWN,
            handleDropdowns
        );
        //setIsLoading(false);
    };

    const getOptions = async () => {
        const api = getHorariosLicenciasByEmpleadoAPI(idEmpleado);
        await executeMangGet(api, ({ data }) => getHorasOptionsCallBack(data));
    }

    const getHorasOptionsCallBack = async (data) => {
        let items = mapDropDownOptionsFromBackendToSelectOptionsNeededForLibrary(data);
        setHorasInicioOptions(items);
        setHorasFinOptions(items);
        setAllHorasOptions(items);
    };

    const handleDropdowns = (data) => {
        setAllDropdowns(data);
    };

    const init = async () => {
        getDropdowns();
        getInitData();
    };

    const getInitData = async () => {
        if (isCreate === true)
            await executeManagePost(getDataToCreateLicenciaAPI(idEmpleado), {}, successGetDataToCreateLicenciaCallback);
        else {
            setAprobadorDisponible(true);
        }
    }

    const successGetDataToCreateLicenciaCallback = ({data}) => {
        if (isNullOrUndefinded(data?.Aprobador))
        {
                setAprobadorDisponible(false);
                toast.error("Aprobadores no disponibles");
        }else{
            setAprobadorDisponible(true);
        }

        setFormValues({...data});
    }

    function getDays() {
        if (formValues[KEYS.FechaInicioCondicion] && formValues[KEYS.FechaFinCondicion])
            return calculateDaysInBetween(formValues[KEYS.FechaInicioCondicion], formValues[KEYS.FechaFinCondicion]);

        return "-";
    }

    function getHoras() {
        if (formValues[KEYS.HoraInicio] && formValues[KEYS.HoraFin])
            return formValues[KEYS.HoraFin] - formValues[KEYS.HoraInicio];

        return "-";
    }

    const cleanForm = () => {
        const keysToKeep = [
            "Aprobador",
            "Area",
            "Empleado",
            "IdTipoLicenciaCondicion",
            "TiposLicencias"
        ];

        const filteredJson = Object.fromEntries(
            Object.entries(formValues).filter(([key]) => keysToKeep.includes(key))
        );

        setFormValues(filteredJson)
    }

    const onChangeRegistradoEnOfisis = async (res) => {
        commonProps(KEYS.registradoEnOfisis).onChange(res);

        const api = ToggleRegistradoEnOfisisAPI();
        const payload = {"IdCondicion": formValues[KEYS.IdCondicion]}
        await executeManagePost(api, payload, () => {});

    };
    //
    const onChangePuedeToggleTieneBonoCapilla = async (res) => {
        commonProps(KEYS.TieneBonoCapilla).onChange(res);

        const api = ToggleTieneBonoCapillaAPI();
        const payload = {"IdCondicion": formValues[KEYS.IdCondicion]}
        await executeManagePost(api, payload, () => {});

    };

    const togglePreviewFormato = () => {
        setShowModalPreviewFormato(!showModalPreviewFormato);
    }

    const toggleConfirmarActualizar = () => {
        setShowModalConfirmarActualizar(!showModalConfirmarActualizar);
    }


    const puedeVerInputFirmar = () => {
        return (isCreate === true && fromAdminPage === false)
    }


    useEffect(() => {
        init();
        getOptions();
    }, []);

    useDidMountEffect(() => {
        if (formValues?.HoraFin){
            let newHoras = allHorasOptions.filter(item => item.value < formValues?.HoraFin);
            setHorasInicioOptions(newHoras);
        }
    }, [formValues?.HoraFin]);

    useDidMountEffect(() => {
        if (formValues?.HoraInicio){
            let newHoras = allHorasOptions.filter(item => item.value > formValues?.HoraInicio);
            setHorasFinOptions(newHoras);
        }

    }, [formValues?.HoraInicio]);

    useDidMountEffect(() => {
        if (!isNullOrUndefinded(formValues?.IdTipoLicenciaCondicion) && !isNullOrUndefinded(formValues?.TiposLicencias)){
            const selectedTipoLicencia = formValues?.TiposLicencias.find(o => o.Value === formValues?.IdTipoLicenciaCondicion) || 'none';
            setSelectedTipoLicencia(selectedTipoLicencia);
            //cleanForm();
        }
    }, [formValues?.IdTipoLicenciaCondicion]);

    useDidMountEffect(() => {
        if (selectedTipoLicencia?.AlRegistrarLicencia_Mostrar_CampoHorario === true && !isNullOrUndefinded(formValues?.FechaInicioCondicion)){
            setFormValues(lastData => ({...lastData, FechaFinCondicion: formValues?.FechaInicioCondicion}));
        }
    }, [formValues?.FechaInicioCondicion]);

    useDidMountEffect(() => {
        togglePreviewFormato()
    }, [togglePreviewFromMainModal]);





    const PapeletaFileInputJSX = (  <InputUploadFile
            label="Papeleta"
            name={KEYS.PapeletaLicenciaCondicion}
            uploadFile={formValues[KEYS.PapeletaLicenciaCondicion]}
            setUploadFile={(res) =>
                setFormValues({...formValues, [KEYS.PapeletaLicenciaCondicion]: res})
            }
            sectionName={SECTION_NAME}
            setIsUploading={setIsUploading}
            validExtensions={EXTENSION_PDF}
            isDisabled={!isCreate || isUploading}
            direction="column"
            NoFileMessage={isUploading ? "Subiendo archivo..." : "No se ha subido archivo"}
            maxFileSize ={2097152} //2MB
            ToastArchivoNoValido = {() => AlertErrorMaxFileSizeMessageGeneric( 'pdf' , '2MB')}

            isRequired
        />)

    const FirmaFileInputJSX = (
        <>
            <InputUploadFile
                label="Firma"
                name={KEYS.FirmaLicenciaCondicion}
                uploadFile={formValues[KEYS.FirmaLicenciaCondicion]}
                setUploadFile={(res) =>
                    setFormValues({...formValues, [KEYS.FirmaLicenciaCondicion]: res})
                }
                sectionName={SECTION_NAME}
                setIsUploading={setIsUploading}
                validExtensions={EXTENSIONES_VALIDAS_DE_IMAGENES}
                isDisabled={!isCreate || isUploading}
                direction="column"
                NoFileMessage={isUploading ? "Subiendo archivo..." : "No se ha subido archivo"}
                maxFileSize ={2097152} //2MB
                ToastArchivoNoValido = {() => AlertErrorMaxFileSizeMessageGeneric( 'jpg o png' , '2MB')}
                isRequired
            />


        </>
    )


    return (
        <>
            {showModalPreviewFormato &&
                <div className="modal-contactanos modal-response-ficha-background">
                    <PreviewFormato showModal={togglePreviewFormato} formValues={formValues}/>
                </div>
            }

            {showModalConfirmarActualizar &&
                <div className="modal-contactanos modal-response-ficha-background">
                    <ConfirmarActualizar toggleModal={toggleConfirmarActualizar} formValues={formValues} handleUpdateFromPreview={handleUpdateFromPreview}/>
                </div>
            }
            <Div>
                <InputText
                    label="Aprobador"
                    {...commonProps(KEYS.Aprobador)}
                    isDisabled={true}
                    placeholder={""}
                    direction={isCreate === true ? "row": "column"}
                />
            </Div>

            {isCreate === false && fromAdminPage === true &&
                <Div col = {3}>
                    <InputBool
                        label="Registrado en Ofisis"
                        name={KEYS.RegistradoEnOfisis}
                        value={formValues[KEYS.RegistradoEnOfisis]}
                        {...commonProps(KEYS.RegistradoEnOfisis)}
                        onChange={onChangeRegistradoEnOfisis}
                        sectionName={SECTION_NAME}
                        isDisabled={!(fromAdminPage && formValues[KEYS.PuedeToggleRegistradoEnOfisis] === true)}
                        direction="column"
                    />
                </Div>
            }

            {isCreate === false && fromAdminPage === true && formValues[KEYS.MostrarCampoBonoCapilla] === true && tipoLicenciaHaSidoEditado === false &&
                <Div col = {3}>
                    <InputBool
                        label="Tiene Bono Capilla"
                        name={KEYS.TieneBonoCapilla}
                        value={formValues[KEYS.TieneBonoCapilla]}
                        {...commonProps(KEYS.TieneBonoCapilla)}
                        onChange={onChangePuedeToggleTieneBonoCapilla}
                        sectionName={SECTION_NAME}
                        isDisabled={!(fromAdminPage && formValues[KEYS.PuedeToggleTieneBonoCapilla] === true)}
                        direction="column"
                    />
                </Div>
            }

            {aprobadorDisponible===true && <>
                <Div col={8}>
                    <InputSelect
                        label="Tipo Licencia"
                        {...selectProps(KEYS.IdTipoLicenciaCondicion, [KEYS.FechaInicioCondicion,
                            KEYS.FechaFinCondicion,
                            KEYS.HoraInicio,
                            KEYS.HoraFin,
                            KEYS.MotivoSolicitud,
                            KEYS.FirmaLicenciaCondicion,
                            KEYS.SustentoLicenciaCondicion])}
                        sectionName={SECTION_NAME}
                        isDisabled={!isEditable}
                        direction="column"
                        isRequired={true}
                    />
                </Div>

                <Div col={4} additionalClass="d-flex justify-content-center align-items-center">
                    <a className="btn generic-button-buscador" style={{width: "135px"}} target="_blank" href={formValues[KEYS.LinkPolitica] ?? ""}>
                        Mira aquí la política
                    </a>
                </Div>

                <Div col={4}>
                    <InputDate
                        label={"Fecha de inicio"}
                        name={KEYS.FechaInicioCondicion}
                        max={selectedTipoLicencia?.AlRegistrarLicencia_Mostrar_CampoHorario === true ? undefined :formValues[KEYS.FechaFinCondicion]}
                        {...commonProps(KEYS.FechaInicioCondicion)}
                        sectionName={SECTION_NAME}
                        isDisabled={!isEditable}
                        isRequired={true}
                        direction="column"
                    />
                </Div>
                <Div col={4}>
                    <InputDate
                        label={"Fecha de fin"}
                        name={KEYS.FechaFinCondicion}
                        min={formValues[KEYS.FechaInicioCondicion]}
                        {...commonProps(KEYS.FechaFinCondicion)}
                        sectionName={SECTION_NAME}
                        isDisabled={!isEditable || selectedTipoLicencia?.AlRegistrarLicencia_Mostrar_CampoHorario === true}
                        isRequired={true}
                        direction="column"
                    />
                </Div>


                <Div col={4}>
                    <InputText
                        label={"Días"}
                        name={"Días"}
                        value={getDays()}
                        sectionName={SECTION_NAME}
                        direction="column"
                        isDisabled
                    />
                </Div>



                {selectedTipoLicencia?.AlRegistrarLicencia_Mostrar_CampoHorario === true &&
                    <>
                        <Div col={4}>
                            <InputSelect
                                label="Hora Inicio"
                                {...selectProps(KEYS.HoraInicio)}
                                sectionName={SECTION_NAME}
                                isDisabled={!isEditable}
                                direction="column"
                                isRequired={true}
                                options={horasInicioOptions}
                            />
                        </Div>

                        <Div col={4}>
                            <InputSelect
                                label="Hora Fin"
                                {...selectProps(KEYS.HoraFin)}
                                sectionName={SECTION_NAME}
                                isDisabled={!isEditable}
                                direction="column"
                                isRequired={true}
                                options={horasFinOptions}
                            />
                        </Div>

                        <Div col={4}>
                            <InputText
                                label={"Horas"}
                                name={"Horas"}
                                value={getHoras()}
                                sectionName={SECTION_NAME}
                                direction="column"
                                isDisabled
                            />
                        </Div>
                    </>
                }


                <Div col={12}>
                    <InputTextArea
                        label="Motivo"
                        {...commonProps(KEYS.MotivoSolicitud)}
                        isDisabled={!isEditable}
                        isRequired={selectedTipoLicencia?.AlRegistrarLicencia_CampoMotivo_EsObligatorio === true}
                        placeholder={"  "}
                        direction="column"
                    />
                </Div>

                {!isNullOrUndefinded(formValues[KEYS.ComentarioRechazoOrObservacion]) && formValues[KEYS.ComentarioRechazoOrObservacion] !== "" &&
                    <Div col={12}>
                        <InputTextArea
                            label={formValues[KEYS.IdEstadoAprobacion] === estados.Rechazado.id ? "Motivo Rechazo" : "Observación"}
                            direction="column"
                            {...commonProps(KEYS.ComentarioRechazoOrObservacion)}
                            placeholder={"  "}
                            isDisabled={true}
                            isRequired={false}
                        />
                    </Div>
                }

                {isCreate === true && fromAdminPage === true &&
                    <Div>
                        {PapeletaFileInputJSX}
                    </Div>
                }
                {puedeVerInputFirmar() &&
                    <Div>
                        {FirmaFileInputJSX}
                    </Div>
                }

                {isCreate === false && !isNullOrUndefinded(formValues[KEYS.PapeletaLicenciaCondicion]) &&
                    <Div>
                        {PapeletaFileInputJSX}
                    </Div>
                }

                {isCreate === false && isNullOrUndefinded(formValues[KEYS.PapeletaLicenciaCondicion]) && formValues?.PuedeGenerarPreview === true &&
                    <Div additionalClass={"d-flex align-items-center"}>
                        <button type='button' className="generic-button-buscador ml-0" onClick={showConfirmarActualizarBeforePreview===true ? toggleConfirmarActualizar : togglePreviewFormato }>
                            Preview Formato
                        </button>
                    </Div>
                }

                <Div>
                    <InputUploadFile
                        toolTipText = "Adjuntar un solo documento en formato pdf, si posees más de un sustento, debes escanear todo como un solo archivo (no mayor de 2MB)"
                        label="Sustento"
                        name={KEYS.SustentoLicenciaCondicion}
                        uploadFile={formValues[KEYS.SustentoLicenciaCondicion]}
                        setUploadFile={(res) =>
                            setFormValues({...formValues, [KEYS.SustentoLicenciaCondicion]: res})
                        }
                        sectionName={SECTION_NAME}
                        setIsUploading={setIsUploadingSustento}
                        validExtensions={EXTENSION_PDF}
                        isDisabled={!isEditable || isUploadingSutento}
                        direction="column"
                        NoFileMessage={isUploadingSutento ? "Subiendo archivo..." : "No se ha subido archivo"}
                        maxFileSize = {2097152} //2MB
                        ToastArchivoNoValido = {() => AlertErrorMaxFileSizeMessageGeneric( 'pdf' , '2MB')}
                        isRequired
                    />
                    <p style={{fontSize: "13px", fontWeight: "600"}}>

                    </p>
                </Div>

                {puedeVerInputFirmar() &&
                   <>
                       <div className='form-check-label ficha-declaracion-jurada-message mt-1'>
                           * Esta firma servirá para generar tu papeleta digital y se eliminará automáticamente después de aprobarse la solicitud.
                       </div>
                       <div className='form-check-label ficha-declaracion-jurada-message'>
                           * Es importante subir tu firma para continuar con el proceso.
                       </div>
                   </>
                }



                {!isNullOrUndefinded(formValues[KEYS.ComentarioTermino]) &&
                    <Div col={12}>
                        <InputTextArea
                            label="Comentario Término"
                            direction="column"
                            sectionName={SECTION_NAME}
                            isDisabled={true}
                            {...commonProps(KEYS.ComentarioTermino)}
                        />
                    </Div>
                }

                {!isNullOrUndefinded(formValues[KEYS.SustentoFileTermino]) &&
                    <Div>
                        <InputUploadFile
                            direction="column"
                            label="Sustento Término"
                            name={KEYS.SustentoFileTermino}
                            uploadFile={formValues[KEYS.SustentoFileTermino]}
                            sectionName={SECTION_NAME}
                            setIsUploading={setIsUploading}
                            validExtensions={["pdf", "jpg", "png"]}
                            isDisabled={true}
                            setUploadFile={(res) => setFormValues({ ...formValues, [KEYS.SustentoFileTermino]: res })}
                        />
                    </Div>
                }

            </>}





        </>
    )
}

export default  LicenciaCondicion;